<app-filter (searchFilterChanged)="doFilter($event)"
[placeholder]="'search_invoices' | i18next"></app-filter>

<div class="row align-items-stretch mt-2">
  @for (invoice of filteredInvoices; track invoice) {
    <app-invoice-card
      class="col-xs-12 col-md-6 col-lg-6 mb-3"
      [invoice]="invoice"
    ></app-invoice-card>
  }
</div>

@if (!filteredInvoices || filteredInvoices.length === 0) {
  <div class="row mt2 red card-h1">
    <div class="col">
      <span>{{'no_invoices' | i18next}}</span>
    </div>
  </div>
}

@if (needsPagination) {
  <div class="d-flex justify-content-center mb-3">
    <button (click)="nextPage()" name="load-more-orders"
    class="btn btn-outline-primary">{{ 'order_load_more_button' | i18next }}</button>
  </div>
}